//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbModal from '@/elements/modal/rb-modal.vue'
import RbPayOverTimeContent from '@/elements/pay-over-time/rb-pay-over-time-content.vue'
import wcs from '@/scripts/libs/wcs'

export default {
  name: 'rb-pay-over-time-modal',
  components: {
    RbPayOverTimeContent,
    RbModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    discountedPrice: {
      type: String,
      default: '',
    },
    prices: {
      type: Object,
      default: () => ({
        discountedPrice: undefined,
        listPrice: '',
        promo: undefined,
        priceFormat: '',
        currencySymbol: '',
      }),
    },
  },
  computed: {
    modalWrapperClass() {
      return wcs.isInPdp() ? 'main' : 'pay-over-time'
    },
  },
  methods: {
    closeModal() {
      this.$emit('closed')
    },
  },
}
